/**
 * Encounter Constants
 */

/**
 * Encounter Status Values
 *
 * Note: 'pending' is the editable/work-in-progress state (conceptually "draft")
 */
export const EncounterStatus = {
  PENDING: 'pending' as const,
  PROCESSING: 'processing' as const,
  COMPLETED: 'completed' as const,
};

export type EncounterStatusType =
  (typeof EncounterStatus)[keyof typeof EncounterStatus];

/**
 * Workflow Staleness Threshold
 *
 * Clear activeWorkflowEncounterId if inactive for this long
 * 1 hour = good balance between crash recovery and stale state cleanup
 */
export const WORKFLOW_STALENESS_THRESHOLD = 60 * 60 * 1000; // 1 hour in milliseconds

/**
 * Touch Workflow Interval
 *
 * Update lastAccessedAt periodically while user actively editing
 * This extends the staleness window during long editing sessions
 */
export const TOUCH_WORKFLOW_INTERVAL = 5 * 60 * 1000; // 5 minutes

/**
 * RTK Query Cache Duration
 *
 * How long to keep unused encounter data in cache
 */
export const ENCOUNTER_CACHE_TTL = 5 * 60; // 5 minutes (in seconds)

/**
 * Feature Tag Types
 *
 * Used for RTK Query cache invalidation
 */
export const ENCOUNTER_TAG_TYPES = ['Encounter', 'EncounterList', 'EncounterDocument'] as const;

export type EncounterTagType = (typeof ENCOUNTER_TAG_TYPES)[number];
